export const inputData = [
  {
    id: 'name',
    placeholder: 'Company Name',
    required: true,
  },
  {
    id: 'type',
    placeholder: 'Company Type (AG, LTD, SA, etc..)',
    required: true,
  },
  {
    id: 'country',
    placeholder: 'Country of Residence',
    required: true,
  },
  {
    id: 'city',
    placeholder: 'Company City Of Residence',
    required: true,
  },
  {
    id: 'province',
    placeholder: 'Company Province Of Residence',
    required: false,
  },
  {
    id: 'address',
    placeholder: 'Company Address',
    required: true,
  },
  {
    id: 'zip',
    placeholder: 'Company Address Postal Code',
    required: true,
  },
  {
    id: 'url',
    placeholder: 'Company URL',
    required: false,
  },
  {
    id: 'document',
  },
  {
    id: 'email',
    placeholder: 'Company representative email',
    required: true,
  },
  {
    id: 'phoneNumber',
    placeholder: 'Company representative phone number',
    required: false,
  },
];

export const roles = [
  {
    name: 'Supplier',
    value: 'supplier',
  },
  {
    name: 'Producer',
    value: 'producer',
  },
  {
    name: 'Logistics',
    value: 'logistics',
  },
  {
    name: 'Distributor',
    value: 'distributor',
  },
  {
    name: 'Reseller',
    value: 'reseller',
  },
  {
    name: 'Discount',
    value: 'discounter',
  },
];
